import { InventoryLocationsApiClient } from '../services/api/inventoryLocations';

let client: InventoryLocationsApiClient;

const locationsFactory = () => (client = new InventoryLocationsApiClient());

/**
 * @deprecated Use `useServices` hook instead.
 */
export const getLocationsApi = (): InventoryLocationsApiClient => client ?? locationsFactory();
